export const TYPE_MAPPING: { [key: string]: string } = {
	DocumentDate: 'DocumentDate',
	BridgeSymbols: 'BridgeSymbols',
};
